import axiosInstance from "./axiosConfig";
import { APIKeys } from '../types/api-key';

export const createApiKey = async (apiKey: APIKeys) => {
    const response = await axiosInstance.post<APIKeys>('/api-keys', apiKey);
    return response?.data;
};

export const updateApiKey = async (apiKey: APIKeys) => {
    const response = await axiosInstance.patch<APIKeys>(`/api-keys/${apiKey.id}`, apiKey);
    return response?.data;
};

export const getApiKeys = async () => {
    const response = await axiosInstance.get<APIKeys[]>('/api-keys');
    return response?.data;
};